module.exports = __webpack_public_path__ + "img/Eritrea.65c9df99.svg";